import React from "react";
import LayerElement from "./layer-element/layer-element";
import TerrainControl from "./terrain-control";
import styles from './layers-control.module.css'
import { useSelector } from "react-redux";
import { getLayers, layersPanel } from "../../../services/reducers/map";

export default function LayersControl() {
    const { selectedPanel } = useSelector(state => state.map);
    const layers = useSelector(getLayers);
    return (
        <div className={`${styles.container} ${selectedPanel !== layersPanel ? styles.collapsed : ''}`}>
            <TerrainControl/>
            <div>
                {layers.map((layer) => (
                    <LayerElement
                        key={layer.id}
                        layer={layer}
                    />
                ))}
            </div>
        </div>
    );
}